import { useState } from 'react';
import { Image } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useManagePath } from '../../context';
import { Preview } from '@/components/shared/image-cropper';
import { ImageCropperDialog } from '@/components/shared/image-cropper/dialog';
import { ImageUploader } from '@/components/shared/image-uploader';

export const ImageUpload = () => {
  const { headerImage, setHeaderImage } = useManagePath();
  const [rawUpload, setRawUpload] = useState<string>('');

  const handleUpload = (image: string | null) => {
    if (image) {
      setRawUpload(image);
    }
  };

  return (
    <>
      {!headerImage?.previewUrl && (
        <ImageUploader onUpload={handleUpload}>
          <Button startIcon={<Image />} variant="outlined">
            Imagem da capa
          </Button>
        </ImageUploader>
      )}
      {headerImage?.previewUrl && (
        <Box
          p={2}
          sx={{
            border: '1px solid',
            borderColor: 'primary.dark',
            borderRadius: 1,
          }}
          width="fit-content"
        >
          <Stack
            direction="row"
            spacing={1}
            mb={2}
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Image fontSize="small" sx={{ color: 'primary.dark' }} />
              <Typography color="primary.dark" fontWeight="semibold">
                Imagem da capa
              </Typography>
            </Stack>
            <Button color="error" onClick={() => setHeaderImage(null)}>
              Remover
            </Button>
          </Stack>
          <Preview
            croppedArea={headerImage.cropArea}
            image={headerImage?.previewUrl ?? ''}
          />
        </Box>
      )}
      {!!rawUpload && (
        <ImageCropperDialog
          image={rawUpload}
          onClose={() => setRawUpload('')}
          onCrop={({ cropArea, originalImage }) =>
            setHeaderImage({
              cropArea,
              blob: originalImage,
              previewUrl: originalImage,
            })
          }
          cropShape="rect"
          aspectRatio={2.5}
        />
      )}
    </>
  );
};
